import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextEditor from '../../components/TextEditor';
import { Helmet } from 'react-helmet-async';
import ImageUploader from '../../components/ImageUploader';
import CategoriesDropdown from '../../components/CategoriesDropdown';
import AdminAddCategory from '../../components/AdminAddCategory';

const AdminIndex = () => {
    const navigate = useNavigate();
    const [content, setContent] = useState();
    const [title, setTitle] = useState();
    const [author, setAuthor] = useState();
    const [previewImgSrc, setPreviewImgSrc] = useState();
    const [description, setDescription] = useState();
    const [selectedCategory, setSelectedCategory] = useState();

    const handleLogout = () => {
        localStorage.removeItem('admin_token');
        navigate('/');
    };

    const handleSave = async () => {
        const token = localStorage.getItem('admin_token');
        if (!token) {
            return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/blogs/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,  // Assuming you are using JWT
            },
            body: JSON.stringify({ title: title, content: content, active: true, author: author, preview_img_src: previewImgSrc, category_id: selectedCategory, description: description }),
        });

        if (response.ok) {
            alert('Content saved successfully');
        } else {
            console.log(response);
            alert('Failed to save content');
        }
    };

    return (
        <div className="d-flex">
            <Helmet>
                <title>Admin Panel - Legalbul</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            {/* Sidebar */}
            <div
                className="bg-dark text-white p-3"
                style={{ width: '250px' }}
            >
                <h3>Admin Panel</h3>
                <ul className="list-unstyled mt-4">
                    <li>
                        <button
                            onClick={handleSave}
                            className="btn btn-success mb-4"
                        >
                            Blogu Kaydet
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/admin/all-blogs')}
                            className="btn btn-primary mb-4"
                        >
                            Tüm Bloglar
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={handleLogout}
                            className="btn btn-danger mb-4"
                        >
                            Çıkış Yap
                        </button>
                    </li>
                </ul>
                <AdminAddCategory />
            </div>

            {/* Main content area */}
            <div className="flex-grow-1 p-4">
                {/* Text Editor */}
                <div className="border p-3">
                    <input
                        type="text"
                        value={author}
                        onChange={(e) => setAuthor(e.target.value)}
                        className="form-control mb-1 w-25 d-inline mx-1"
                        placeholder="Yazar"
                    />
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="form-control mb-3 mx-1"
                        placeholder="Açıklama yazısı (SEO)"
                    />
                    <CategoriesDropdown setCategory={setSelectedCategory} />
                    <ImageUploader setPreviewImgSrc={setPreviewImgSrc} />

                    <TextEditor setOuterContent={setContent} setOuterTitle={setTitle} />
                </div>
            </div>
        </div>
    );
};

export default AdminIndex;
